import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TestReportingDataService } from '../../data-services/testReporting.service';
import moment from 'moment';
import { ButtonModule } from 'primeng/button';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { ngfModule } from "angular-file";

@Component({
  selector: 'app-upload-strand-pcr-file',
  templateUrl: './uploadStrandPCRFile.html',
  providers: [MessageService],
  imports: [ButtonModule, Toast, CommonModule, ngfModule]
})
export class UploadStrandPCRFileComponent implements OnInit {

  constructor(
    private messageService: MessageService,
    private testReportingService: TestReportingDataService) {
  }

  loading: boolean;
  showSpinner: boolean = false;
  files: File[] = [];

  fileUploading: boolean = false;
  uploadFormData: FormData;
  acceptTypes: string = "text/csv";


  ngOnInit() {

  }

  public uploadFilesChanged() {
    if (this.files.length != 1) {
      console.log('Unexpected file count found - ' + this.files.length.toString());
      return;
    }

    var fileName = this.files[0].name;
    var reader = new FileReader();
    reader.readAsBinaryString(this.files[0]);
    reader.onload = (event) => {
      var fileContent = btoa(event.target.result.toString());

      this.testReportingService.uploadStrandDocument(fileName, fileContent).subscribe((data: any) => {
        this.testReportingService.getStrandAccessionFile(fileName).subscribe((response: any) => {
          if (response) {
            let file = new Blob([response], { type: 'text/csv' });
            var fileURL = URL.createObjectURL(file);
            this.createLinkWithFriendlyName(fileURL, fileName);

            //window.open(fileURL);
          }
        }, (err) => {
            this.messageService.add({ sticky: true, severity: 'error', summary: 'Unable to retrieve accession file ', detail: 'Failed: ' + err.error });
        });
        this.messageService.add({ sticky: true, severity: 'success', summary: 'PCR file successfully uploaded' });
      }, (err) => {
        console.log(`Error: ` + err.error)
        this.fileUploading = false;
          this.messageService.add({ sticky: true, severity: 'error', summary: 'Error Uploading File ', detail: 'Failed: ' + err.error });
      });
 
    };

    this.files = [];
 }

  private createLinkWithFriendlyName(fileURL, fileName: string) {
    var formattedDate = moment(Date.now()).format('MMDDYYYY_hhmmssA');
    var downloadName: string = fileName.replace(".csv", ".accession." + formattedDate + ".csv");

    var fileLink = document.createElement('a');
    fileLink.href = fileURL;
    fileLink.download = downloadName;
    fileLink.click();
    this.messageService.add({ sticky: true, severity: 'success', summary: 'Accession file ' + downloadName + ' successfully downloaded. It can be found in your local downloads folder.' });
  }

  public removeToast() {
    this.messageService.clear();
  }
}
